
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/privateAppsPanel/components/InstalledAppIndicator/installedAppIndicator.scss.css.virtualfile';
        module.exports = {"installedAppIndicator":"_installedAppIndicator_1eor1_1"};